import configData from "./AppConfig.json";

// Brand options
export const BRAND_DEFAULT = "Default";
export const BRAND_CENTENARY = "Centenary";
export const BRAND_LYSAGHT = "Lysaght";

// Determine the brand and debug mode
const url = document.location.href.split("?")[0];
const params = new URLSearchParams(document.location.search);
let debug = false;
let brand = BRAND_DEFAULT;
if (/centenary/gi.test(url)) {
    brand = BRAND_CENTENARY;
} else if (/lysaght/gi.test(url)) {
    brand = BRAND_LYSAGHT;
} else if (
    /localhost/gi.test(url) ||
    /192\.168\./g.test(url) ||
    /hi-ar\.azurewebsites\.net/gi.test(document.location.href)
) {
    debug = true;
    if (params.has("brand")) {
        const brandParam = params.get("brand").toLocaleLowerCase();
        if (brandParam === BRAND_CENTENARY.toLocaleLowerCase()) {
            brand = BRAND_CENTENARY;
        } else if (brandParam === BRAND_LYSAGHT.toLocaleLowerCase()) {
            brand = BRAND_LYSAGHT;
        }
    }
}
export const APP_BRAND = brand;
export const APP_DEBUG = debug;

// Determine the API location
const api = debug ? "debug" : /test\./gi.test(url) ? "test" : "live";
export const APP_API = configData.Api[api];

// Get the job id
export const APP_JOB = params.has("job") ? params.get("job") : "";

// Determine the model Url
let model = "";
if (params.has("model") && debug) {
    model = params.get("model");
} else if (APP_JOB) {
    model = `${APP_API}obj/${APP_JOB}/${APP_JOB}.glb`;
}
export const APP_MODEL = model;

/**
 * Initialises document title and relevant links based on the brand.
 */
export function initDoc() {
    document.title = `${configData.Brand[APP_BRAND].name} AR App - ${APP_JOB}`;
    // document.querySelector("link[rel='icon']").href = configData.Brand[APP_BRAND].icon;
    // document.querySelector("link[rel='apple-touch-icon']").href = configData.Brand[APP_BRAND].appleIcon;
    // document.querySelector("link[rel='manifest']").href = configData.Brand[APP_BRAND].manifest;
}
